import { put, takeLatest } from 'redux-saga/effects'
import {
  UDPATE_ACCOUNT_ACTIVATE_DATA,
  UDPATE_ACCOUNT_ACTIVATE_DATA_SUCCESSED,
  CHECK_ACTIVATION,
  CHECK_ACTIVATION_FAILED,
  CHECK_ACTIVATION_SUCCESSED,
  USER_ACTIVATION,
  USER_ACTIVATION_SUCCESSED,
  USER_ACTIVATION_FAILED
} from '../actions/actionTypes'
import { ApiService } from '../services/ApiService'
import moment from 'moment'
const _apiService = new ApiService()

function* updateAccountActivateData(action) {

  yield put({
    type: UDPATE_ACCOUNT_ACTIVATE_DATA_SUCCESSED,
    data: Object.assign({
    }, action.params)
  })
}

export function* watchUpdateAccountActivateData() {
  yield takeLatest(UDPATE_ACCOUNT_ACTIVATE_DATA, updateAccountActivateData)
}


function* checkAccountActivationStatus(action) {
  try {
    let payload = {
      userLogin: action.params.refnum,
      firstName: action.params.firstname,
      lastName: action.params.lastname,
      last4ofSSN: action.params.ssn,
      dob: moment(new Date(action.params.dob)).format('YYYY-MM-DD')
    }
    let response = yield _apiService.getBasicInfo(payload)

    if (!response || response.error) {
      if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
        var responseErrMsg = response.errorData.response.data.message
        var description = response.errorData.response.data.description
        //Failed or already claim
        yield put({
          type: CHECK_ACTIVATION_FAILED,
          message: responseErrMsg,
          infoError: responseErrMsg,
          data: Object.assign({
          }, { allowClaim: false, message: responseErrMsg, description: description })
        })
      } else {
        yield put({
          type: CHECK_ACTIVATION_FAILED,
          message: response.error || 'An error has occurred'
        })
      }

    } else {
      //Success, allow to claim
      yield put({
        type: CHECK_ACTIVATION_SUCCESSED,
        data: Object.assign({
        }, { allowClaim: true })
      })
    }
  } catch (error) {
    yield put({
      type: CHECK_ACTIVATION_FAILED,
      message: error.message
    })
  }


}

export function* watchCheckAccountActivationStatus() {
  yield takeLatest(CHECK_ACTIVATION, checkAccountActivationStatus)
}

//activate user
function* activateUser(action) {

  try {
    let payload = {
      userLogin: action.params.refnum,
      firstName: action.params.firstname,
      lastName: action.params.lastname,
      last4ofSSN: action.params.ssn,
      dob: moment(new Date(action.params.dob)).format('YYYY-MM-DD'),
      password: action.params.password,
      confirmPassword: action.params.confirmpassword,
      challengeQuestions: [{
        name: action.params.question1,
        value: action.params.answer1
      }, {
        name: action.params.question2,
        value: action.params.answer2
      }, {
        name: action.params.question3,
        value: action.params.answer3
      }]
    }

    let response = yield _apiService.updateClaim(payload)
    //Failed to activate
    if (!response || response.error) {
      if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
        var responseErrMsg = response.errorData.response.data.message
        yield put({
          type: CHECK_ACTIVATION_FAILED,
          message: responseErrMsg,
          infoError: responseErrMsg
        })
      } else {
        yield put({
          type: USER_ACTIVATION_FAILED,
          message: response.error || 'An error has occurred'
        })
      }
    } else {
      //Success activated

      if(response.passwordError){
        yield put({
          type: CHECK_ACTIVATION_FAILED,
          message: response.passwordError,
          infoError: response.passwordError
        })
      }else{
      yield put({
        type: USER_ACTIVATION_SUCCESSED,
        data: Object.assign({
        }, response)
      })
    }
    }
  } catch (error) {
    yield put({
      type: USER_ACTIVATION_FAILED,
      message: error.message
    })
  }
}

export function* watchActivateUser() {
  yield takeLatest(USER_ACTIVATION, activateUser)
}